import {type FunctionalComponent, h} from '@stencil/core';
import type { SearchApiDocumentMySE } from '../../../../../../api/model/response/documents/private/MySEDocument';
import { UiaasSearchLabelList } from '../../../../result-cards/subcomponents/uiaas-search-label-list';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';

export interface IDashboardOrderItemProperties {
    doc: SearchApiDocumentMySE;
    labelProvider: labelProviderInterface;
}

export const DashboardOrderItemLabels: FunctionalComponent<IDashboardOrderItemProperties> = (props) => {
    const { doc, labelProvider } = props;

    return (
      <span><UiaasSearchLabelList
        list={[
          {
            label: labelProvider('result.seamless.customerPONumber', 'PO Number'),
            value: doc?.customerPONumber,
          },
          {
            label: labelProvider('result.seamless.releaseDate', 'Release date'),
            value: doc?.releaseDate,
          },
          {
            value: labelProvider('result.seamless.' + doc.source, doc.source),
            customValueClass: 'private__category',
          }
        ].filter(e=>e.value)}
      />
      <br/>
      <UiaasSearchLabelList
        list={[
          {
            label: labelProvider('result.seamless.shipTo', 'Ship to'),
            value: doc.shipZIP && `${doc.shipAddress1}, ${doc.shipZIP} ${doc.shipCity}, ${doc.shipState || '-'}`
          },
          {
            label: labelProvider('result.seamless.transactionDate', 'Transaction Date'),
            value: doc.transactionDate
          },
          {
            label: labelProvider('result.seamless.invoiceValue', 'Total'),
            value: doc.invoiceValue && `${doc.invoiceValue} ${doc.currency}`
          },
          {
            label: labelProvider('result.seamless.returnReason', 'Reason for return'),
            value: doc.returnReason
          },
          {
            label: labelProvider('result.seamless.returnType', 'Type of return'),
            value: doc.returnType
          },
          {
            label: labelProvider('result.seamless.returnOrderDate', 'Return order date'),
            value: doc.returnOrderDate
          },
          {
            label: labelProvider('result.seamless.creationDate', 'Creation Date'),
            value: doc.creationDate
          },
          {
            label: labelProvider('result.salesforce.endDate', 'End date'),
            value: doc.contractEndDate
          },
          {
            label: labelProvider('result.seamless.projectName', 'Project'),
            value: doc.projectName
          },
          {
            label: labelProvider('result.seamless.dispatchNumber', 'Dispatch number'),
            value: doc.trackingNumber
          },
          {
            label: labelProvider('result.seamless.deliveryNumber', 'Delivery number'),
            value: doc.deliveryNumber
          },
          {
            label: labelProvider('result.seamless.expeditionDate', 'Expedition date'),
            value: doc.expeditionDate
          },
        ].filter(e=>e.value)}
      />
      </span>);
};
